import { render } from "./ChatWidget.vue?vue&type=template&id=012b0320&scoped=true"
import script from "./ChatWidget.js?vue&type=script&lang=js&external"
export * from "./ChatWidget.js?vue&type=script&lang=js&external"

import "./ChatWidget.vue?vue&type=style&index=0&id=012b0320&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012b0320"]])

export default __exports__